import script from "./Conseiller.vue?vue&type=script&setup=true&lang=js"
export * from "./Conseiller.vue?vue&type=script&setup=true&lang=js"

import "./Conseiller.vue?vue&type=style&index=0&id=35efbad8&lang=stylus"

const __exports__ = script;

export default __exports__